import { render, staticRenderFns } from "./HoverMenu.vue?vue&type=template&id=40d52172"
import script from "./HoverMenu.vue?vue&type=script&lang=js"
export * from "./HoverMenu.vue?vue&type=script&lang=js"
import style0 from "./HoverMenu.vue?vue&type=style&index=0&id=40d52172&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports